export default __webpack_public_path__ + "static/olevel-1-56b7e8c379bf29f4aba2feaee90a2f4c.jpg";